/** Permissions that allow the My Files (audio library) page and instance media uploads. */
export const myFilesPagePermissions = ['ManageImages', 'CreateJourneySet', 'CreateJourneyTemplate'] as const;

export function userCanAccessMyFiles(permissions: string[] | undefined | null): boolean {
    if (!permissions?.length) return false;
    return myFilesPagePermissions.some((p) => permissions.includes(p));
}
